import { render, staticRenderFns } from "./comMenuForm.vue?vue&type=template&id=0759c922&scoped=true&"
import script from "./comMenuForm.vue?vue&type=script&lang=js&"
export * from "./comMenuForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0759c922",
  null
  
)

export default component.exports